module.exports = __webpack_public_path__ + "img/antes_despues_183.e92a5d1c.png";